module.exports = __webpack_public_path__ + "static/media/hero-background-1.f704dbc5.png";